import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50fa4900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_links mr-1",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "hover-underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked', $event))),
      class: "btn btn-link px-0 text-brand1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1)
      ])
    ])
  ]))
}